<template>
    <div>
        <div v-if="tokens.length > 0">
            <div class="card card-default">
                <div class="card-header"><strong>Authorized Applications</strong></div>

                <div class="card-body">
                    <!-- Authorized Tokens -->
                    <table class="table table-striped table-borderless mb-0">
                        <thead>
                        <tr>
                            <th>Name</th>
                            <th>Scopes</th>
                            <th></th>
                        </tr>
                        </thead>

                        <tbody>
                        <page-loader v-if="loading" :loading="true"/>
                        <template v-else-if="tokens.length > 0">
                            <template v-for="token in tokens">
                                <tr v-if="geReferringPlatform(token.clientUuid).clientUuid">
                                    <!-- Client Name -->
                                    <td
                                        :class="{
                                                    'text-decoration-line-through': !!token.revoked,
                                                    'font-weight-bold': !token.revoked,
                                                }"
                                        style="vertical-align: middle;"
                                    >
                                        {{ geReferringPlatform(token.clientUuid).displayName }}
                                    </td>

                                    <!-- Scopes -->
                                    <td
                                        :class="{ 'text-decoration-line-through': token.revoked }"
                                        style="vertical-align: middle;"
                                    >
                                            <span v-if="!!token.scopes && token.scopes.length > 0">
                                                {{ token.scopes.join(', ') }}
                                            </span>
                                        <template v-else>-</template>
                                    </td>

                                    <!-- Revoke Button -->
                                    <td nowrap style="vertical-align: middle;width:1%">
                                        <a
                                            :class="{
                                                    'btn-danger': !token.revoked,
                                                    'btn-warning': !!token.revoked
                                                }"
                                            class="btn btn-sm action-link"
                                            @click="revokeToggle(token)"
                                        >
                                            {{ token.revoked ? 'Allow' : 'Revoke' }} access
                                        </a>
                                    </td>
                                </tr>
                            </template>
                        </template>
                        <template v-else>
                            <tr>
                                <td colspan="10">
                                    <center>No authorized applications found.</center>
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FrontEndApiService from "@services/frontend.api.service";
import {getActiveThirdPartyPlatformList} from "@helpers/api-helper";

export default {
    name: "ReferringPlatformClients",

    /*
     * The component's data.
     */
    data() {
        return {
            tokens: [],
            referringPlatforms: [],
            loading: false,
        };
    },

    /**
     * Prepare the component (Vue 1.x).
     */
    ready() {
        this.prepareComponent();
    },

    /**
     * Prepare the component (Vue 2.x).
     */
    mounted() {
        this.prepareComponent();
    },

    methods: {
        /**
         * Prepare the component (Vue 2.x).
         */
        prepareComponent() {
            this.getTokens();
        },

        /**
         * Get all of the authorized tokens for the user.
         */
        getTokens() {
            this.loading = true;
            this.sendToEndpoint('auth-codes/search')
                .then(async response => {
                    let tokens = ((response.data || {}).data || []).filter(tk => tk && !!tk.uuid)
                            .map(tk => ({uuid: tk.uuid, ...(tk.attributes || {})})),
                        tokenclientUuids = tokens.map(tk => tk.clientUuid)
                    ;

                    !tokens.length || (
                        this.referringPlatforms = (await getActiveThirdPartyPlatformList())
                            .filter(p => tokenclientUuids.includes(p?.clientUuid)) || []
                    );
                    this.$nextTick(() => {
                        this.tokens = tokens;
                        this.loading = false;
                    });
                });
        },

        /**
         * Revoke the given token.
         */
        revokeToggle(tk) {
            let token = {...tk},
                uuid = tk.uuid;

            token.revoked = !token.revoked;
            delete token.uuid;
            delete token.scopes;

            this.sendToEndpoint(`auth-codes/${uuid}`, token)
                .then(() => {
                    this.getTokens();
                });
        },

        async sendToEndpoint(endpoint, data = {}) {
            try {
                FrontEndApiService.init(window.env.MILESTONES_API_HOST);
                return await FrontEndApiService.post(`api/v1/oauth/${endpoint}`, data);
            } catch (error) {
                throw error;
            }
        },

        geReferringPlatform(clientUuid) {
            return this.referringPlatforms.find(tk => tk.clientUuid === clientUuid) || {};
        },
    }

}
</script>

<style scoped>
.action-link {
    cursor: pointer;
}
</style>